<div class="" id="rooms-and-guests-popover-{{ randomNumber }}">
  @if (!isMobile) {
    <app-b2b-popover-v1 [width]="'300px'" [border]="'none'" [top]="'30px'">
      <div header>
        <ng-container
          *ngTemplateOutlet="commonTemplate"
        ></ng-container>
      </div>
      <div body>
        @if (selectedRoomGuestData) {
          <div class="checkin-sdw">
            @if ((('PopOverRoomGuestPickerComponent' | b2bDynamicLoaderPipe) | async); as component; ) {
              <div [appLoader]="component" [compData]="selectedRoomGuestData"
                   appB2bDynamicLoader
                   (dismissEvent)="setFieldValue($event, selectedRoomGuestData);dismissPopover(roomGuestPopover, selectedRoomGuestData);"
              >
              </div>
            }
          </div>
        }
      </div>
    </app-b2b-popover-v1>
  } @else {
    <ng-container
      *ngTemplateOutlet="commonTemplate"
    ></ng-container>
  }

  <!--@if (!isMobile) {
    <app-b2b-popover
      class="rooms-guests-popover" #roomGuestPopover
      [trigger]="'rooms-and-guests-popover-' + randomNumber"
      [offsetWidth]="100"
    >
      @if (selectedRoomGuestData) {
        <div popoverContent class="checkin-sdw">
          @if ((('PopOverRoomGuestPickerComponent' | b2bDynamicLoaderPipe) | async); as component; ) {
            <div [appLoader]="component" [compData]="selectedRoomGuestData"
                 appB2bDynamicLoader
                 (dismissEvent)="setFieldValue($event, selectedRoomGuestData);dismissPopover(roomGuestPopover, selectedRoomGuestData);"
            >
            </div>
          }
        </div>
      }
    </app-b2b-popover>
  }-->
</div>

<ng-template #commonTemplate>
  <div (click)="onOpenRoomGuestElement()" class="rm-gst-detail">
    @if (selectedRoomGuestData?.selectedValue) {
      <div class="gst-vle">
        <span class="title">{{ selectedRoomGuestData?.selectedValue?.title }}</span>
        <span class="arrow"></span>
      </div>
    } @else {
      <div class="err-msg">Add Guest, Children</div>
    }
  </div>
</ng-template>
